import React, { useEffect, useState } from 'react';
import axios from 'axios';
import qs from 'qs';
import Access from "../components/Access";
import Navbar from "../components/Navbar";
import { ReactComponent as Add } from '../Img/icon-add.svg';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import Dialog from "../components/Dialog";

const Clients = (props) =>
{
    const [modalVisible, setModalVisible] = useState(false);
    const [clients, setClients] = useState([]);
    const [id_organisme, setId_organisme] = useState('');
    const [nom, setNom] = useState('');
    const [nom_complement, setNom_complement] = useState('');
    const [num_voie, setNum_voie] = useState('');
    const [num_suffixe, setNum_suffixe] = useState('');
    const [type_voie, setType_voie] = useState('');
    const [nom_voie, setNom_voie] = useState('');
    const [complement_adresse, setComplement_adresse] = useState('');
    const [code_postale, setCode_postale] = useState('');
    const [ville, setVille] = useState('');
    const [nom_destinataire, setNom_destinataire] = useState('');
    
    // nouvel état pour édition/suppression
    const [editingClient, setEditingClient] = useState(null); // null => création, objet => édition
    
    // état pour Dialog personnalisé
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');
    
    // tri par nom : null | 'asc' | 'desc'
    const [nameSort, setNameSort] = useState(null);
    const sortClientsByName = (order) => {
        setClients(prev => {
            const copy = Array.isArray(prev) ? [...prev] : [];
            copy.sort((a, b) => {
                const na = (a.nom || '').toString().toLowerCase();
                const nb = (b.nom || '').toString().toLowerCase();
                if (na === nb) return 0;
                return order === 'asc' ? na.localeCompare(nb) : nb.localeCompare(na);
            });
            return copy;
        });
    };
    const onNameHeaderClick = () => {
        const next = nameSort === 'asc' ? 'desc' : 'asc';
        setNameSort(next);
        sortClientsByName(next);
    };
    
    const purple = '#6571FE';
    const blue = '#069BD3';
    const green = '#59B44A';
    
    const [dialogModalVisible, setDialogModalVisible] = useState(false);
    
    async function callbackDialog(ret) {
        if (ret === true) {
            deleteClient();
        }
    }

    async function mount()
    {
        if (props.user && props.user.id_organisme) {
            setId_organisme(String(props.user.id_organisme));
            var params = {
                'get': true,
                'id_organisme': props.user.id_organisme
            };
            await axios.post('/api/clients_epfl.php', qs.stringify(params))
            .then((res) => {
                // back renvoie {status:1, count, data: [...] } ou tableau direct
                if (res && res.data) {
                    if (Array.isArray(res.data)) setClients(res.data);
                    else if (res.data.data) setClients(res.data.data);
                    else setClients(res.data);
                } else {
                    setClients([]);
                }
            })
            .catch((err) => {
                console.warn(err)
            })
        }
    }

    useEffect(() => {
        if (props.user === null) {
            props.getUser()
        }
        else {
            mount();
        }
    }, [props.user])

    useEffect(() => {
        // Empêche le scroll du body quand la popup est ouverte
        document.body.style.overflow = modalVisible ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [modalVisible]);

    useEffect(() => {
        // Ferme la popup sur Escape
        function onKey(e) {
            if (e.key === 'Escape') {
                setModalVisible(false);
                clearForm();
            };
        }
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, []);

    const clearForm = () => {
        setId_organisme('');
        setNom('');
        setNom_complement('');
        setNum_voie('');
        setNum_suffixe('');
        setType_voie('');
        setNom_voie('');
        setComplement_adresse('');
        setCode_postale('');
        setVille('');
        setNom_destinataire('');
        setEditingClient(null);
    };

    // ouvre la popup en mode création
    const openCreateModal = () => {
        clearForm();
        // préremplir id_organisme si disponible
        if (props.user && props.user.id_organisme) setId_organisme(String(props.user.id_organisme));
        setModalVisible(true);
    };

    // ouvre la popup pour éditer un client
    const openEditModal = (client) => {
        setEditingClient(client);
        setId_organisme(client.id_organisme ? String(client.id_organisme) : '');
        setNom(client.nom || '');
        setNom_complement(client.nom_complement || '');
        setNum_voie(client.num_voie !== null && client.num_voie !== undefined ? String(client.num_voie) : '');
        setNum_suffixe(client.num_suffixe || '');
        setType_voie(client.type_voie || '');
        setNom_voie(client.nom_voie || '');
        setComplement_adresse(client.complement_adresse || '');
        setCode_postale(client.code_postale || '');
        setVille(client.ville || '');
        setNom_destinataire(client.nom_destinataire || '');
        setModalVisible(true);
    };

    const createClient = async () => {
        if (!nom || !nom.trim()) {
            // affiche le Dialog au lieu de l'alerte
            setDialogMessage("Le champ « Nom du client » est requis.");
            setDialogOpen(true);
            return;
        }
        try {
            const params = {
                create: true,
                id_organisme: id_organisme,
                nom: nom,
                nom_complement: nom_complement,
                num_voie: num_voie,
                num_suffixe: num_suffixe,
                type_voie: type_voie,
                nom_voie: nom_voie,
                complement_adresse: complement_adresse,
                code_postale: code_postale,
                ville: ville,
                nom_destinataire: nom_destinataire
            };
            const res = await axios.post('/api/clients_epfl.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success("Client créé avec succès.", '', 2000);
                await mount();
                setModalVisible(false);
                clearForm();
            } else {
                const msg = res && res.data && res.data.message ? res.data.message : 'Erreur création client';
                NotificationManager.error(msg, '', 4000);
                console.warn('Erreur création client', res && res.data ? res.data : res);
            }
        } catch (e) {
            NotificationManager.error("Erreur lors de la requête de création.", '', 4000);
            console.error(e);
        }
    };

    const updateClient = async () => {
        if (!editingClient || !editingClient.id) return;
        if (!nom || !nom.trim()) {
            // affiche le Dialog au lieu de l'alerte
            setDialogMessage("Le champ « Nom du client » est requis pour la modification.");
            setDialogOpen(true);
            return;
        }
        try {
            const params = {
                update: true,
                id: editingClient.id,
                id_organisme: id_organisme,
                nom: nom,
                nom_complement: nom_complement,
                num_voie: num_voie,
                num_suffixe: num_suffixe,
                type_voie: type_voie,
                nom_voie: nom_voie,
                complement_adresse: complement_adresse,
                code_postale: code_postale,
                ville: ville,
                nom_destinataire: nom_destinataire
            };
            const res = await axios.post('/api/clients_epfl.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success("Client mis à jour.", '', 2000);
                await mount();
                setModalVisible(false);
                clearForm();
            } else {
                const msg = res && res.data && res.data.message ? res.data.message : 'Erreur mise à jour client';
                NotificationManager.error(msg, '', 4000);
                console.warn('Erreur mise à jour client', res && res.data ? res.data : res);
            }
        } catch (e) {
            NotificationManager.error("Erreur lors de la requête de mise à jour.", '', 4000);
            console.error(e);
        }
    };

    const deleteClient = async () => {
        if (!editingClient || !editingClient.id) return;
        try {
            const params = {
                delete: true,
                id: editingClient.id
            };
            const res = await axios.post('/api/clients_epfl.php', qs.stringify(params));
            if (res && res.data && res.data.status === 1) {
                NotificationManager.success("Client supprimé.", '', 2000);
                await mount();
                setModalVisible(false);
                clearForm();
            } else {
                const msg = res && res.data && res.data.message ? res.data.message : 'Erreur suppression client';
                NotificationManager.error(msg, '', 4000);
                console.warn('Erreur suppression client', res && res.data ? res.data : res);
            }
        } catch (e) {
            NotificationManager.error("Erreur lors de la requête de suppression.", '', 4000);
            console.error(e);
        }
    };

    // tri générique
    const [sortField, setSortField] = useState(null); // 'nom' | 'adresse' | 'code_postale' | 'ville' | 'nom_destinataire'
    const [sortOrder, setSortOrder] = useState('asc'); // 'asc' | 'desc'

    const getFieldValue = (c, field) => {
        switch (field) {
            case 'nom':
                return (c.nom || '').toString().toLowerCase();
            case 'adresse': {
                // concatène les morceaux d'adresse pour trier sur l'ensemble
                const parts = [
                    c.num_voie ? String(c.num_voie) : '',
                    c.num_suffixe || '',
                    c.type_voie || '',
                    c.nom_voie || '',
                    c.complement_adresse || ''
                ];
                return parts.join(' ').toLowerCase();
            }
            case 'code_postale':
                return (c.code_postale || '').toString().toLowerCase();
            case 'ville':
                return (c.ville || '').toString().toLowerCase();
            case 'nom_destinataire':
                return (c.nom_destinataire || '').toString().toLowerCase();
            default:
                return '';
        }
    };

    const onHeaderClick = (field) => {
        const nextOrder = (sortField === field && sortOrder === 'asc') ? 'desc' : 'asc';
        setSortField(field);
        setSortOrder(nextOrder);

        setClients(prev => {
            const copy = Array.isArray(prev) ? [...prev] : [];
            copy.sort((a, b) => {
                const va = getFieldValue(a, field);
                const vb = getFieldValue(b, field);
                if (va === vb) return 0;
                return nextOrder === 'asc' ? (va > vb ? 1 : -1) : (va < vb ? 1 : -1);
            });
            return copy;
        });
    };

    return (
        <div>
            <Access needConnection={true} type_user={[1, 2]}>
                <Navbar user={props.user} />
                <NotificationContainer />
                
                <Dialog
                    setModalVisible={setDialogModalVisible}
                    modalVisible={dialogModalVisible}
                    callbackDialog={callbackDialog}
                    message={"Confirmez la suppression :"}
                />

                <div style={{display: 'flex', margin: 25}}>
                    <p>Gestion \</p>
                    <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Collectivités</p>
                    <div style={{flex: 1}}></div>
                    <button
                    className='shadow-md rounded-md'
                    style={{backgroundColor: green, color: 'white', marginLeft: 20, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft:10, paddingRight: 10}}
                    onClick={openCreateModal}>
                        <Add width="12"/>
                        <p style={{marginLeft: 5}}>Nouvelle collectivité</p>
                    </button>
                </div>

                {/* POPUP Nouvelle collectivité / Edition */}
                {modalVisible &&
                    <div
                        onClick={() => {
                            setModalVisible(false);
                            clearForm();
                        }}
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0,0,0,0.4)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 9999
                        }}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            role="dialog"
                            aria-modal="true"
                            style={{
                                width: 720,
                                maxWidth: '95%',
                                backgroundColor: 'white',
                                borderRadius: 8,
                                padding: 20,
                                boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
                                textAlign: 'left',
                                maxHeight: '90vh',
                                overflowY: 'auto'
                            }}
                        >
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10}}>
                                <h3 style={{margin: 0}}>{editingClient ? 'Modifier la collectivité' : 'Créer une nouvelle collectivité'}</h3>
                                <button onClick={() => { setModalVisible(false); clearForm(); }} style={{border: 'none', background: 'transparent', cursor: 'pointer', fontSize: 18}}>✕</button>
                            </div>

                            <div style={{display: 'flex', flexWrap: 'wrap', gap: 12}}>
                                <div style={{width: '100%'}}>
                                    <label style={{display: 'block', marginBottom: 6}}>Nom de la collectivité</label>
                                    <input value={nom} onChange={e => setNom(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Nom de la collectivité" />
                                </div>

                                <div style={{flex: '1 1 45%'}}>
                                    <label style={{display: 'block', marginBottom: 6}}>Complément de nom</label>
                                    <input value={nom_complement} onChange={e => setNom_complement(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Complément de nom" />
                                </div>

                                <div style={{flex: '1 1 45%'}}>
                                    <label style={{display: 'block', marginBottom: 6}}>Numéro de voie</label>
                                    <input value={num_voie} onChange={e => setNum_voie(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Ex: 12" />
                                </div>

                                <div style={{flex: '1 1 45%'}}>
                                    <label style={{display: 'block', marginBottom: 6}}>Numéro suffixe (BIS, TER...)</label>
                                    <input value={num_suffixe} onChange={e => setNum_suffixe(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Ex: BIS" />
                                </div>

                                <div style={{flex: '1 1 45%'}}>
                                    <label style={{display: 'block', marginBottom: 6}}>Type de voie</label>
                                    <select value={type_voie} onChange={e => setType_voie(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}}>
                                        <option value="">-- Sélectionner --</option>
                                        <option>Rue</option>
                                        <option>Avenue</option>
                                        <option>Boulevard</option>
                                        <option>Chemin</option>
                                        <option>Impasse</option>
                                        <option>Place</option>
                                        <option>Allée</option>
                                        <option>Route</option>
                                    </select>
                                </div>

                                <div style={{flex: '1 1 45%'}}>
                                    <label style={{display: 'block', marginBottom: 6}}>Nom de la voie</label>
                                    <input value={nom_voie} onChange={e => setNom_voie(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Nom de la voie" />
                                </div>

                                <div style={{width: '100%'}}>
                                    <label style={{display: 'block', marginBottom: 6}}>Complément d'adresse</label>
                                    <input value={complement_adresse} onChange={e => setComplement_adresse(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Bâtiment, étage, BP..." />
                                </div>

                                <div style={{flex: '1 1 45%'}}>
                                    <label style={{display: 'block', marginBottom: 6}}>Code postal</label>
                                    <input value={code_postale} onChange={e => setCode_postale(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Ex: 75001" />
                                </div>

                                <div style={{flex: '1 1 45%'}}>
                                    <label style={{display: 'block', marginBottom: 6}}>Ville</label>
                                    <input value={ville} onChange={e => setVille(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Ville" />
                                </div>

                                <div style={{width: '100%'}}>
                                    <label style={{display: 'block', marginBottom: 6}}>Nom destinataire</label>
                                    <input value={nom_destinataire} onChange={e => setNom_destinataire(e.target.value)} style={{width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc'}} placeholder="Nom du destinataire" />
                                </div>
                            </div>

                            <div style={{display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 14}}>
                                <button
                                    onClick={() => { setModalVisible(false); clearForm(); }}
                                    style={{padding: '8px 12px', borderRadius: 4, backgroundColor: '#eee', border: 'none', cursor: 'pointer'}}
                                >
                                    Annuler
                                </button>

                                {editingClient ? (
                                    <>
                                        <button
                                            onClick={() => {
                                                setModalVisible(false);
                                                setDialogModalVisible(true);
                                            }}
                                            style={{padding: '8px 12px', borderRadius: 4, backgroundColor: '#d9534f', color: 'white', border: 'none', cursor: 'pointer'}}
                                        >
                                            Supprimer
                                        </button>
                                        <button
                                            onClick={updateClient}
                                            style={{padding: '8px 12px', borderRadius: 4, backgroundColor: '#f0ad4e', color: 'white', border: 'none', cursor: 'pointer'}}
                                        >
                                            Mettre à jour
                                        </button>
                                    </>
                                ) : (
                                    <button
                                        onClick={createClient}
                                        style={{padding: '8px 12px', borderRadius: 4, backgroundColor: green, color: 'white', border: 'none', cursor: 'pointer'}}
                                    >
                                        Créer
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                }

                {/* Listing des collectivités */}
                <div style={{margin: 25}}>
                    {(() => {
                        const list = Array.isArray(clients) ? clients : (clients && clients.data ? clients.data : []);
                        if (!list || list.length === 0) {
                            return <div style={{color: '#666'}}>Aucune collectivité pour cet organisme.</div>;
                        }
                        return (
                            <>
                                {/* En-tête (gardée) */}
                                <div style={{display: 'flex', padding: '8px 12px', borderBottom: '1px solid #ddd', alignItems: 'center', fontWeight: 600, color: '#333'}}>
                                    <div style={{flex:3, minWidth:0, cursor:'pointer'}} onClick={() => onHeaderClick('nom')}>
                                        Nom
                                        {sortField === 'nom' && (sortOrder === 'asc' ? <span style={{fontSize:10, marginLeft: 6}}>▲</span> : <span style={{fontSize:10, marginLeft: 6}}>▼</span>)}
                                    </div>
                                    <div style={{flex:4, minWidth:0, cursor:'pointer'}} onClick={() => onHeaderClick('adresse')}>
                                        Adresse
                                        {sortField === 'adresse' && (sortOrder === 'asc' ? <span style={{fontSize:10, marginLeft: 6}}>▲</span> : <span style={{fontSize:10, marginLeft: 6}}>▼</span>)}
                                    </div>
                                    <div style={{flex:2, minWidth:80, textAlign: 'center', cursor:'pointer'}} onClick={() => onHeaderClick('code_postale')}>
                                        Code postal
                                        {sortField === 'code_postale' && (sortOrder === 'asc' ? <span style={{fontSize:10, marginLeft: 6}}>▲</span> : <span style={{fontSize:10, marginLeft: 6}}>▼</span>)}
                                    </div>
                                    <div style={{flex:3, minWidth:120, textAlign: 'center', cursor:'pointer'}} onClick={() => onHeaderClick('ville')}>
                                        Ville
                                        {sortField === 'ville' && (sortOrder === 'asc' ? <span style={{fontSize:10, marginLeft: 6}}>▲</span> : <span style={{fontSize:10, marginLeft: 6}}>▼</span>)}
                                    </div>
                                    <div style={{flex:2, minWidth:160, textAlign: 'center', cursor:'pointer'}} onClick={() => onHeaderClick('nom_destinataire')}>
                                        Destinataire
                                        {sortField === 'nom_destinataire' && (sortOrder === 'asc' ? <span style={{fontSize:10, marginLeft: 6}}>▲</span> : <span style={{fontSize:10, marginLeft: 6}}>▼</span>)}
                                    </div>
                                </div>

                                {/* Liste en boutons */}
                                <div style={{display:'flex', flexDirection:'column', gap:8, marginTop:8}}>
                                    {list.map(c => (
                                        <button
                                            key={c.id}
                                            onClick={() => openEditModal(c)}
                                            style={{
                                                display: 'flex',
                                                width: '100%',
                                                textAlign: 'left',
                                                padding: '12px',
                                                borderRadius: 6,
                                                border: '1px solid #eee',
                                                background: 'white',
                                                cursor: 'pointer',
                                                alignItems: 'flex-start',
                                                gap: 12
                                            }}
                                        >
                                            <div style={{flex:3, minWidth:0}}>
                                                <div style={{fontWeight:600}}>{c.nom || ''}</div>
                                                {c.nom_complement ? <div style={{fontSize:12, color:'#666'}}>{c.nom_complement}</div> : null}
                                            </div>

                                            <div style={{flex:4, minWidth:0}}>
                                                <div style={{whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>
                                                    {c.num_voie ? c.num_voie : ''}{c.num_suffixe ? ' ' + c.num_suffixe : ''} {c.type_voie ? c.type_voie + ' ' : ''}{c.nom_voie ? c.nom_voie : ''}
                                                </div>
                                                {c.complement_adresse ? <div style={{fontSize:12, color:'#666'}}>{c.complement_adresse}</div> : null}
                                            </div>

                                            <div style={{flex:2, minWidth:80, textAlign:'center'}}>{c.code_postale || ''}</div>
                                            <div style={{flex:3, minWidth:120, textAlign:'center'}}>{c.ville || ''}</div>
                                            <div style={{flex:2, minWidth:160, textAlign:'center'}}>{c.nom_destinataire || ''}</div>
                                        </button>
                                    ))}
                                </div>
                            </>
                        );
                    })()}
                </div>

            </Access>
        </div>
    );
}

export default Clients;
